module.exports = __webpack_public_path__ + "img/reaction12.14ba99b5.png";